import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {ResponseCode} from "@app/constants/Common";
import {requestSaveCandidateGroup} from "@app/services/CandidateGroupService";
import {validateSaveCandidateGroup} from "@pages/savedlist/common/ValidateUtils";
import {InitSavedListInfo, SavedListLevels, SavedListTabOptions} from "@pages/savedlist/common/Constant";
import {stringToArray} from "@app/utils/CommonUtils";
import Select from "react-select";
import {showMessage} from "@app/constants/Messages";

const UpdateCandidateGroupModal = (props) => {
    const [group, setGroup] = useState(
        InitSavedListInfo
    );

    const [isLoading, setIsLoading] = useState(false)
    const {isShow} = props
    const {groupInfo} = props
    const {onClose} = props

    useEffect(() => {
        if (groupInfo) {
            const cloneGroup = {...groupInfo}
            cloneGroup.candidate_ids = stringToArray(cloneGroup.candidate_ids)

            SavedListTabOptions.forEach(item => {
                if (item.value === groupInfo.tab) {
                    cloneGroup.tab = item
                }
            })

            setGroup(cloneGroup)
        }
    }, [groupInfo]);

    const onUpdateGroupInfo = () => {
        if (!validateSaveCandidateGroup(group)) {
            return;
        }

        const body = {...group}
        body.tab = group.tab.value

        setIsLoading(true)
        requestSaveCandidateGroup(body).then((res) => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                onClose(true)
            } else if (res.sts_code === ResponseCode.EXISTS_SAVED_LIST) {
                showMessage("Tên saved list đã tồn tại trên phần mềm", false, true, true)
            } else {
                showMessage("Cập nhật saved list thất bại", false, true, true)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const setGroupItem = (event) => {
        group[event.target.name] = event.target.value
        setGroup({...group})
    }

    const setTabItem = (values) => {
        group.tab = values
        setGroup({...group})
    }

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={onClose}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Cập nhật thông tin saved list</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                ID: {group.id}
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <input type='text' className='form-control' placeholder='Tên saved list'
                                       value={group.name}
                                       name={'name'} onChange={event => setGroupItem(event)}/>
                            </div>
                        </div>
                        {/*<div className='col-sm-12'>*/}
                        {/*    <div className='form-group'>*/}
                        {/*        Số persons: {group.candidate_ids ? group.candidate_ids.length : 0}*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className='col-sm-12'>*/}
                        {/*    <div className='form-group'>*/}
                        {/*        Ngày tạo: {group.created_date_time}*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className='col-sm-12'>*/}
                        {/*    <div className='form-group'>*/}
                        {/*        Ngày cập nhật: {group.updated_date_time}*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <div style={{width: '100%'}}>
                                    <label className={'w-100'}>Tên Tab</label>
                                    <Select options={SavedListTabOptions}
                                            value={group.tab}
                                            name={'tab'}
                                            placeholder={'Tên Tab'}
                                            onChange={value => {
                                                setTabItem(value);
                                            }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <label className={'w-100'}>Level</label>
                                <select className={`form-control`}
                                        value={group.level}
                                        name={'level'}
                                        placeholder={'Level'}
                                        onChange={event => setGroupItem(event)}>
                                    {SavedListLevels.map(item => (
                                        <option value={item} key={`candidate-group-option-item-${item}`}>{item}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <input type='text' className='form-control' placeholder='Notes'
                                       value={group.notes}
                                       name={'notes'} onChange={event => setGroupItem(event)}/>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type='button'
                            className='btn btn-primary'
                            isLoading={isLoading}
                            disabled={
                                isLoading
                            }
                            onClick={() => {
                                onUpdateGroupInfo()
                            }}
                            >
                        <i className='fas fa-save mr-2'/>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default UpdateCandidateGroupModal;
